import { Box, styled } from '@mui/material'
import { spacing } from '@/styles/designTokens'

export const StyledVerifyContentWrapper = styled(Box)({
	width: '100%',
})

export const StyledLoadingContent = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: spacing.sm,
	justifyContent: 'center',
})
